import { VueFire } from "vuefire";
import { firebaseApp } from "./plugins/firebase.js";
import VCalendar from "v-calendar";
import "v-calendar/style.css";
import Toast from "vue-toastification";
import "vue-toastification/dist/index.css";

/**
 * Browser-only plugins (must not be imported from entry-server).
 * GA4 / Google Ads: GTM via VITE_GTM_ID + dataLayer (see src/helpers/analytics.js).
 */
export function registerClientOnlyPlugins(app) {
    app.use(VueFire, { firebaseApp });
    app.use(VCalendar, {
        locales: {
            ar: {
                firstDayOfWeek: 6,
                masks: {
                    L: "YYYY/MM/DD",
                    title: "MMMM YYYY",
                },
                dayNames: ["الأحد", "الاثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"],
                dayNamesShort: ["أحد", "اثن", "ثلا", "أرب", "خمي", "جمع", "سبت"],
                monthNames: [
                    "يناير",
                    "فبراير",
                    "مارس",
                    "أبريل",
                    "مايو",
                    "يونيو",
                    "يوليو",
                    "أغسطس",
                    "سبتمبر",
                    "أكتوبر",
                    "نوفمبر",
                    "ديسمبر",
                ],
                monthNamesShort: ["ينا", "فبر", "مار", "أبر", "ماي", "يون", "يول", "أغس", "سبت", "أكت", "نوف", "ديس"],
            },
        },
    });
    app.use(Toast);
}
